import { commonApi } from '@common/utils/baseQuery';
import config from '@config';
import type { GetUserWorldCupPredictionResponse, SaveUserWorldCupPredictionRequest } from './types';

const injectedWorldCupForecastApi = commonApi.injectEndpoints({
  endpoints: (build) => ({
    getUserWorldCupPrediction: build.query<GetUserWorldCupPredictionResponse | null, void>({
      query: () => '/footballforecast/bets',
    }),
    saveUserWorldCupPrediction: build.mutation<void, SaveUserWorldCupPredictionRequest>({
      query: (data) => ({
        url: '/footballforecast/bets',
        body: data,
        method: 'POST',
      }),
    }),
    fetchWorldCupRules: build.query<string, string>({
      query: (locale) => ({
        url: `${config.cdn}/world_cup_2026/wc26_rules_${locale}.html`,
        responseHandler: (response) => response.text(),
      }),
      extraOptions: { useToken: false },
    }),
  }),
  overrideExisting: false,
});

export const worldCupForecastApi = injectedWorldCupForecastApi;
export const {
  useGetUserWorldCupPredictionQuery,
  useSaveUserWorldCupPredictionMutation,
  useFetchWorldCupRulesQuery,
} = worldCupForecastApi;
